module.exports = __webpack_public_path__ + "static/media/icon-clock-white.95ea248b.svg";